import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { profileApi } from 'src/api/profile.api';
import type { UserProfile } from 'src/types/UserProfile';
import type { RootState } from '../store';

interface UserProfileState {
  profile: UserProfile | null;
}

const initialState: UserProfileState = {
  profile: null,
};

export const userProfileReducer = createSlice({
  name: 'userProfileReducer',
  initialState,
  reducers: {
    updateProfileImage: (state, action: PayloadAction<string>) => {
      if (state.profile) {
        state.profile.image_url = action.payload;
      }
    },
    setUserProfile: (state, action: PayloadAction<UserProfile>) => {
      state.profile = action.payload;
    },
    updateMobileNumber: (state, action: PayloadAction<string>) => {
      if (state.profile) {
        state.profile.mobile_number = action.payload;
      }
    },
    clearUserProfile: state => {
      state.profile = null;
    },
  },
  extraReducers: builder => {
    builder
      .addMatcher(profileApi.endpoints.getUserProfile.matchFulfilled, (state, action) => {
        state.profile = action.payload;
      })
      .addMatcher(profileApi.endpoints.updatePhoneNumber.matchFulfilled, (state, action) => {
        if (state.profile) {
          state.profile.mobile_number = action.meta.arg.originalArgs.mobile_number;
        }
      });
  },
});

export const { updateProfileImage, setUserProfile, updateMobileNumber, clearUserProfile } = userProfileReducer.actions;

export const selectUserProfile = (state: RootState) => state.userProfileReducer.profile;
